export const en_US = {
  general: {
    error: {
      pageNotFound: "Page not found.",
      somethingWentWrong: "Something went wrong.",
      noDataFound: "No data found.",
    },
    text: {
      backToHomePage: "Back to homepage",
      select: "Select",
      back: "Back",
      previous: "Previous",
      next: "Upcoming",
    },
  },
  header: {
    home: "Home",
    members: "Members",
    events: "Events",
    photos: "Photos",
    contact: "Contact",
    settings: "Settings",
  },
  home: {
    title: "Home",
    informations: {
      latestVideo: {
        title: "Latest video",
        description: "Below you can see our latest video from Next Generation.",
      },
      members: {
        title: "Who are we?",
        description:
          "Welcome to our website! We are Next Generation, a Dutch Christian band from the Harderwijk, Ermelo, and Putten area. We play with all our love for God's kingdom, and we have been doing this since 2021!",
        buttonLabel: "Go to members page",
      },
      events: {
        title: "When do we play?",
        description:
          "We mainly perform in our own church - NGK De Oever in Ermelo. Sometimes we also play elsewhere, which you can see on the Events page of this website. Here, you can also find more information!",
        buttonLabel: "Go to events page",
      },
      contact: {
        title: "How can you get in touch with us?",
        description:
          "You can contact us through various channels. You can send us a message via social media, or you can fill out a contact form on the Contact page. You can also find our social media there.",
        buttonLabel: "Go to contact page",
      },
    },
  },
  members: {
    title: "Members",
    description:
      "Here you can see who's part of Next Generation. You can see informations of the members.",
    memberDescription: (firstName: any, age: any, role: any) => {
      return `Hi, I'm ${firstName} and I'm
      ${age} years old. I am the 
      ${role} of Next
      Generation. If you have any questions for me you can fill out a contact form!`;
    },
    age: "Age",
    instrument: "Instrument",
    role: "Role",
  },
  events: {
    title: "Events",
    location: "Location",
    time: "Time",
    description: "Here you can see all our events that will happen soon.",
    futureEvents: "Upcoming events",
    previousEvents: "Previous events",
  },
  photos: {
    title: "Photos",
    description: "Here you can see all the photos.",
  },
  contact: {
    title: "Contact us",
    popup: "Message sent successfully!",
    description:
      "If you want to contact us, please fill out the form below or follow us on socials!",
    form: {
      subject: "Subject",
      email: "Email",
      message: "Message",
      submit: "Send message",
    },
  },
  settings: {
    title: "Settings",
    description: "Here you can change your own personal settings.",
  },
  construction: {
    title: "Under construction",
    pageDescription: "This page is under construction.",
    description:
      "Our website is under construction. We'll be here soon with our new site.",
  },
};
